import React, { ChangeEvent, FocusEvent, forwardRef } from "react";
import { Advice, InputContainer, InputHTML, Label } from "./styles";
interface IInput {
  label?: string;
  advice?: string;
  type?: React.HTMLInputTypeAttribute;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  id?: string;
  onlyChar?: boolean;
  onlyCharAndNumber?: boolean;
  maxWidth?: string;
  placeholder?: string;
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
  maxLength?: number;
  $inputWidth?: string;
  inlyNumber?: boolean;
  disabled?: boolean;
  readonly?: boolean;
}

const FormInput = forwardRef<HTMLInputElement, IInput>(
  (
    {
      label,
      advice,
      onChange,
      value,
      id,
      type,
      onlyChar,
      onlyCharAndNumber,
      inlyNumber,
      maxWidth,
      placeholder = "",
      onFocus,
      maxLength,
      $inputWidth = "100%",
      disabled = false,
      readonly = false
    },
    ref
  ) => {
    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (onlyChar && !/[a-zA-Z]/.test(e.key)) {
        e.preventDefault();
      }
      if (onlyCharAndNumber && !/[a-zA-Z0-9]/.test(e.key)) {
        e.preventDefault();
      }
      if (inlyNumber && !/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    };

    return (
      <InputContainer $maxWidth={maxWidth}>
        <Label htmlFor={id}>{label}</Label>
        <InputHTML
          ref={ref}
          type={type || "text"}
          onChange={onChange}
          value={value}
          id={id}
          placeholder={placeholder}
          onFocus={onFocus}
          maxLength={maxLength}
          $inputwidth={$inputWidth}
          onKeyPress={handleKeyPress}
          disabled={disabled}
          readOnly={readonly}
        />
        <Advice>{advice}</Advice>
      </InputContainer>
    );
  }
);

export default FormInput;
